import { prisma, SendGridChannel, ResourceType, ActionType } from "client";

// CREATE
export const createSendGridChannel = async (
  userId: string,
  data: SendGridChannel
) => {
  try {
        const sendGridChannel = await prisma.sendGridChannel.create({
      data: {
        ...data,
      },
    });
    return { sendGridChannel };
  } catch (error) {
    return { error };
  }
};

// READ
export const getAllSendGridChannels = async (
  userId: string
): Promise<{
  sendGridChannels?: SendGridChannel[];
  error?: any;
}> => {
  try {
        const sendGridChannels = await prisma.sendGridChannel.findMany();
    return { sendGridChannels };
  } catch (error) {
    return { error };
  }
};

export const getSendGridChannelById = async (id: string) => {
  try {
    const sendGridChannel = await prisma.sendGridChannel.findUnique({
      where: { id },
    });
    return { sendGridChannel };
  } catch (error) {
    return { error };
  }
};

// UPDATE
export const updateSendGridChannelById = async (
  userId: string,
  id: string,
  data: SendGridChannel
) => {
  try {
        const sendGridChannel = await prisma.sendGridChannel.update({
      where: { id },
      data: {
        ...data,
      },
    });
    return { sendGridChannel };
  } catch (error) {
    return { error };
  }
};

// DELETE
export const deleteSendGridChannelById = async (userId: string, id: string) => {
  try {
        const sendGridChannel = await prisma.sendGridChannel.delete({
      where: { id },
    });
    return { sendGridChannel };
  } catch (error) {
    return { error };
  }
};
